import { render } from "./registerLocationUser.vue?vue&type=template&id=3f2ffa90"
import script from "./registerLocationUser.vue?vue&type=script&lang=js"
export * from "./registerLocationUser.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__